<script>
    import { createEventDispatcher } from 'svelte'
    import { Link, navigate } from 'svelte-routing'
    import { FormGroup, Form, FormText, Input, Label, Button,
        Container, Row, Col,
        Card, CardSubtitle, CardText, CardBody, CardHeader, CardTitle } from 'sveltestrap'

    const dispatch = createEventDispatcher()

    export let project = null
    export let pageTitle = ''

    let changes = {}

    const track = {
        project: (field) => {
            changes[field] = project[field]
        }
    }

    const onSave = () => dispatch('submit', changes)

</script>

<Container class="mt-4">
    <Row>
        <Col><Link on:click={() => window.history.back()}><i class="fa fa-arrow-left"></i><span style="margin-left: 8px">Back</span></Link></Col>
    </Row>
    <Row>
        <Col>
            <div class="cardHeader">
                <Card>
                    <CardHeader>
                        <h4 class="float-left">{pageTitle}</h4>
                    </CardHeader>
                    <CardBody>
                            <FormGroup>
                                <Label for="name">Name</Label>
                                <Input id="name" placeholder="Name" bind:value={project.name} on:change={() => track.project('name')} />
                            </FormGroup>
                        <Button color="primary" on:click={onSave}>Save</Button>
                    </CardBody>
                </Card>
            </div>
        </Col>
    </Row>
</Container>